import { TranslationKey } from './../../../../../types/translation/TranslationKey';
import React, { useContext, useState } from 'react';
import { t } from '../../../../../types/translation/Translator';
import { OrderMutations, UpdateOrderResponse, UpdateOrderVariables } from '../../../../../graphql/order.graphql';
import { OrderContext } from '../../../../../context/OrderContext';
import CreateOrderUserPane from './Panes/CreateOrderUserPane';
import { testIds } from '../../../../../util/identifiers/identifiers.util';
import Modal from '../../../../../VentoryUI/components/common/Modal/Modal';
import { Order, OrderInput } from '../../../../../types/order/';
import { useMutation } from '@apollo/client';

interface AssignOrderUserModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
  order: OrderInput;
  setOrder: (order: OrderInput) => void;
}

export default function AssignOrderUserModal({ open, setOpen, order, setOrder }: AssignOrderUserModalProps) {
  if (!open) return null;

  const { orders, setOrders } = useContext(OrderContext);
  const [orderInput, setOrderInput] = useState<OrderInput>(new OrderInput(order));

  const [update, { loading }] = useMutation<UpdateOrderResponse, UpdateOrderVariables>(OrderMutations.update, {
    onCompleted: res => {
      const o = res.updateOrder[0];
      orders.set(o.id, new Order(o));
      setOrders(new Map(orders));
      setOrderInput(new OrderInput(o));
      setOrder(new OrderInput(o));
      handleClose();
    },
  });

  const handleSave = async () => {
    await update({
      variables: {
        orders: [orderInput.forUpdate()],
      },
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      height='550px'
      title={t(TranslationKey.reassignUsers).singular.label}
      testId={testIds.createOrderModal}
    >
      <CreateOrderUserPane
        loading={loading}
        order={orderInput}
        setOrder={setOrderInput}
        save={handleSave}
        cancel={handleClose}
      />
    </Modal>
  );
}
